import { monday } from '../services/monday';

export function ExternalLink({ href, children, ...otherProps }: { href: string; children: React.ReactNode; [key: string]: any }) {
  return (
    <a
      href={href}
      rel="noopener noreferrer"
      {...otherProps}
      onClick={(ev) => {
        ev.preventDefault();
        monday.execute('openLinkInTab', { url: href });
      }}
    >
      {children}
    </a>
  );
}
